import { Injector } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormID } from '@finxone-platform/form-action';
import { UserMarketingPreference } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { UpdateFormDataActionWithId } from '../../../actions/form-submission.action';
import { ProfileState } from '../../../state/user-profile.state';

export function assignMarketingPreferencesValuesToForm(injector: Injector, formGroup: FormGroup): void {
  const store = injector.get(Store);
  const marketingPreferences = store.selectSnapshot(ProfileState.getMarketingPreferences);
  const valuesToPatch = Object.keys(marketingPreferences)
    .map((key) => {
      return marketingPreferences[key as keyof UserMarketingPreference] === true ? key : null;
    })
    .filter((key) => key !== null);
  formGroup.controls['marketingPreferences']?.patchValue(valuesToPatch, { emitEvent: false });
  store.dispatch(new UpdateFormDataActionWithId(formGroup.value, FormID.MARKETING_PREFERENCES_FORM));
}
